import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import {
	MAT_DIALOG_DATA,
	MatDialogRef,
	MatDialogTitle,
	MatDialogContent,
	MatDialogActions,
	MatDialogClose,
} from '@angular/material/dialog'
import { Observable, of } from 'rxjs'
import { AbstractFormDialog } from '../dialog/abstract-form-dialog'
import { LoadingService } from '../../core/services/loading.service'
import { ShopSettings } from '../../../../domain/user/shop-settings.model'
import { ShopSettingsFirestoreService } from '../../core/firestore-services/shop-settings-firestore.service'
import { ReactiveFormsModule } from '@angular/forms'
import { FmxFormSubmitDirective } from '../modules/form/submit/form-submit.directive'
import { CdkScrollable } from '@angular/cdk/scrolling'
import { SettingsFormComponent } from './settings-form.component'
import { FmxControlSubmitDirective } from '../modules/form/submit/control-submit.directive'
import { NgIf, AsyncPipe } from '@angular/common'
import { MatError } from '@angular/material/select'
import { MatButton } from '@angular/material/button'
import { TranslatePipe } from '@ngx-translate/core'

@Component({
	selector: 'app-settings-edit-dialog',
	template: `
		<form [formGroup]="form" (fmxSubmit)="onSubmit()">
			<h2 matDialogTitle>{{ 'tab.setari' | translate }}</h2>

			<mat-dialog-content>
				<app-settings-form formControlName="model"></app-settings-form>
				<mat-error *ngIf="errors$ | async as errors" class="mb-3">{{ errors }}</mat-error>
			</mat-dialog-content>

			<div mat-dialog-actions>
				<button mat-button mat-dialog-close class="btn-custom-default">{{ 'actiune.inchide' | translate }}</button>
				<button
					mat-raised-button
					type="submit"
					color="primary"
					class="btn-custom-primary"
					[disabled]="loadingService.loading$ | async"
				>
					{{ 'actiune.actualizeaza' | translate }}
				</button>
			</div>
		</form>
	`,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		ReactiveFormsModule,
		FmxFormSubmitDirective,
		MatDialogTitle,
		CdkScrollable,
		MatDialogContent,
		SettingsFormComponent,
		FmxControlSubmitDirective,
		NgIf,
		MatError,
		MatDialogActions,
		MatButton,
		MatDialogClose,
		AsyncPipe,
		TranslatePipe,
	],
})
export class SettingsEditDialog extends AbstractFormDialog<ShopSettings, SettingsEditDialog> {
	protected readonly dialogRef: MatDialogRef<SettingsEditDialog>
	readonly loadingService: LoadingService
	readonly settings = inject<ShopSettings>(MAT_DIALOG_DATA)
	private readonly shopSettingsFirestoreService = inject(ShopSettingsFirestoreService)

	constructor() {
		const dialogRef = inject<MatDialogRef<SettingsEditDialog>>(MatDialogRef)
		const loadingService = inject<LoadingService>(LoadingService)

		super(dialogRef, loadingService)

		this.dialogRef = dialogRef
		this.loadingService = loadingService
	}

	protected initialFormValue(): ShopSettings {
		return this.settings
	}

	protected action$(model: ShopSettings): Observable<unknown> {
		return of(this.shopSettingsFirestoreService.update(model))
	}

	protected getErrorMessage(err: unknown, model: ShopSettings): string {
		return `Nu s-au putut actualiza setarile magazinului`
	}

	protected getSuccessMessage(model: ShopSettings): string {
		return `Setarile magazinului au fost actualizate!`
	}
}
